import React, { createContext, useContext, useState } from "react"


type HotelContextProviderProps = {
    children  : React.ReactNode
}


type HotelContextType = {
    HotelId : string 
    // setHotelId : React.Dispatch<React.SetStateAction<string>>
    setHotelId : (Id : string) => void

    HotelName : string 
    // setHotelName : React.Dispatch<React.SetStateAction<string>>
    setHotelName : (Name : string) => void

}


// export const UserContext = createContext({} as UserContextType)
export const HotelContext = createContext({} as HotelContextType)
// export const UserContext = createContext<UserContextType | null>(null)

export const HotelContextProvider =  
({children} : HotelContextProviderProps) => {
  
    // const [user, setUser] = useState<AuthUser | null>(null)  // this technique is called as Union type
console.log('---HotelContext ApI initialization----');

    let item =  localStorage.getItem('HotelId');
    const [HotelId, setHotel_Id ] = useState<string>(item ? item : '');

    const setHotelId = (Id : string) => {
        setHotel_Id(Id);
        localStorage.setItem("HotelId", Id);
    }

    const setHotelName = (Name : string) => {
        setHotel_Name(Name);
        localStorage.setItem("HotelName", Name);
    }
    
    let itemName =  localStorage.getItem('HotelName');
    const [HotelName, setHotel_Name ] = useState<string>(itemName ? itemName : '');
    

    return (
    <HotelContext.Provider value={{HotelId, setHotelId, HotelName, setHotelName}}>
          {children} 
    </HotelContext.Provider>
    )
    

}


export const useHotel2 = () => useContext(HotelContext)
